/**
 * 모달 겹침 층(z-index) — 값을 흩어 두면 반드시 갈라진다.
 *
 * CLAUDE.md 모달 z 정책(root `z-[70]` / sub `z-[80]`, `z-50` 금지)에는 **3층 이상이 없었다.**
 * 그래서 각 모달이 자기 값을 상수로 박아 뒀고, 한 층을 올리는 순간 그 위에 열리는 모달이
 * 뒤로 숨는 사고가 났다:
 *
 *  - 2026-08-11: 위임 모달(sub) 안에서 결재라인 편집이 root 값이라 뒤로 숨음 → 편집을 sub2로 올림
 *  - 그 직후: 편집(sub2) 위에서 여는 '담당자 추가'가 sub 값이라 이번엔 그쪽이 숨음
 *
 * 층은 **여는 쪽이 정한다**(같은 컴포넌트가 여러 깊이에서 쓰이므로 자기 층을 고정할 수 없다).
 * 새 층이 필요하면 여기에 추가하고, 모달은 문자열을 박지 말고 이 상수를 참조한다.
 *
 * 오버레이 농도: 겹쳐 뜨는 층은 아래 화면이 비쳐야 맥락이 유지되므로 옅게(`bg-black/25`) 쓴다.
 */
export const MODAL_LAYER = {
  /** 화면 위 첫 모달. Layout 헤더(z-[60])·고정 배너(`BANNER_LAYER` — z-[56]~z-[58])보다 위. */
  root: 'z-[70]',
  /** 모달 위의 모달 — 위임 모달, 상세에서 연 담당자 추가 등. */
  sub: 'z-[80]',
  /** sub 위의 모달 — 위임 모달 안에서 연 결재라인 편집. */
  sub2: 'z-[90]',
  /** sub2 위의 모달 — 그 편집 모달 안에서 연 담당자 추가. */
  sub3: 'z-[100]',
} as const;

export type ModalLayer = (typeof MODAL_LAYER)[keyof typeof MODAL_LAYER];

/**
 * 헤더 아래 고정 배너 층 — 모달과 같은 이유로 한 자리에 둔다(리뷰 1103 F15: 세 배너가 값을 각자 박아
 * 서로의 주석으로만 순서를 맞추고 있었다). 순서는 **차단성이 위**다: 기관 인증 > 확인이 필요한 항목 > 공지 띠.
 * 모두 헤더(`z-[60]`)보다 낮고 모달(`MODAL_LAYER.root`)보다 낮다. 바텀 네비 dim(`z-[55]`)은 그 아래다.
 * ⚠️ Tailwind는 소스의 **리터럴**만 생성하므로 값은 이 파일에 완성된 클래스 문자열로 둔다(조립하지 말 것).
 */
export const BANNER_LAYER = {
  /** 기관 인증 대기(`VerificationPendingBanner`) — 차단성 */
  verification: 'z-[58]',
  /** 확인이 필요한 항목(`ActionItemsBar`) */
  actionItems: 'z-[57]',
  /** 공지 띠(`AnnouncementBand`) — 차단성도 조치 대상도 아니다 */
  announcement: 'z-[56]',
} as const;

/** 겹쳐 뜨는 층의 오버레이 농도 — 아래 맥락이 비치도록 root보다 옅다. */
export const SUB_MODAL_OVERLAY_BG = 'bg-black/25';
